import { linkResolver } from 'prismic/linkResolver';

import { Link } from 'components/link/Link';

import styles from './TransparentButton.module.scss';
import { PrismicLinkWithMeta } from 'prismic/types/link';

interface TransparentLinkProps {
  text: string;
  link?: PrismicLinkWithMeta;
  style?: 'small';
}
const TransparentLink = ({ text, link, style }: TransparentLinkProps) => {
  const linkStyle = `${styles.transparentButton} ${style ? styles[style] : ''}`;

  if (!link) {
    return <div className={linkStyle}>{text}</div>;
  }

  return (
    <Link to={linkResolver(link)} className={linkStyle}>
      {text}
    </Link>
  );
};

export default TransparentLink;
